module.exports = __webpack_public_path__ + "img/Rogue-troll-f-70.12b85ee5.gif";